export default "__VITE_ASSET__DTBc4pow__"